import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  name: 'Index',
  data: function data() {
    return {
      defaultMenu: '/configuration'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['name'])), {}, {
    key: function key() {
      return this.$route.fullPath;
    }
  }),
  created: function created() {
    if (this.$route.matched[0].path !== '') {
      this.defaultMenu = this.$route.matched[0].path;
    } else {
      this.defaultMenu = this.$route.matched[1].path;
    }
  },
  methods: {
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};